﻿import * as Res from "./res";
import openSignaturePopup from "./_signature";
import { createElement } from "./_dom";
import { registerComponent } from "./component";

function displaySignOffPrompt(label) {
	const title = Res.getString("signature.action.sign_off");
	const addButton = createElement("button", {
			type: "button",
			title,
			class: "v3-signature__add v3-button"
		},
		createElement("div", { class: "v3-signature__placeholder-container" },
			createElement("span", { class: "v3-signature__placeholder" }, Res.getString("signature.action.sign_off")),
			createElement("i", { class: "ui-icon-add ui-icon-only" }))
	);
	label.classList.remove("v3-signature");
	label.classList.add("v3-signature-prompt");
	label.replaceChildren(addButton);
}

function displaySignature(label, fileUrl, allowRemove, needConfirm) {
	const labelChildren = [
		createElement('img', { src: fileUrl, class: 'v3-signature__img' }),
		allowRemove && createElement('button', { type: "button", class: "v3-signature__delete v3-button", "data-confirm": needConfirm && Res.getString("signature.action.withdraw.confirmation") }, Res.getString("signature.action.withdraw"))
	];
	label.classList.remove("v3-signature-prompt");
	label.classList.add("v3-signature");
	label.replaceChildren(...labelChildren);
}

function createSignaturePicker(fileInput) {
	fileInput.hidden = true;
	// const parent = fileInput.parentNode;
	const fileName = fileInput.dataset.filename;
	const fileUrl = fileInput.dataset.fileurl;
	const fileData = /^data:/.test(fileUrl) ? fileUrl : "";
	const name = fileInput.name;
	const label = createElement('span', { class: "v3-signature" });
	const hiddenInput = createElement('input', { type: 'hidden', name: `${name}_sign`, value: fileData });
	const allowRemove = fileInput.dataset.allowremove != null;
	
	if (fileName && fileUrl) {
		displaySignature(label, fileUrl, allowRemove, true);
	} else {
		displaySignOffPrompt(label);
		hiddenInput.value = '';
	}
	fileInput.after(hiddenInput);
	hiddenInput.after(label);
	label.addEventListener('click', ({ target }) => {
		const deleteButton = target.closest(".v3-signature__delete");
		if (deleteButton) {
			const deleteConfirmed = deleteButton.dataset.confirm == null || confirm(deleteButton.dataset.confirm);
			if (deleteConfirmed) {
				hiddenInput.after(createElement("input", { type: "checkbox", name: `${name}_delete`, "checked": true, hidden: true }));
				displaySignOffPrompt(label);
				hiddenInput.value = '';
			}
		} else if (target.closest(".v3-signature__add")) {
			const setImgSrc = (src) => {
				displaySignature(label, src, true, false);
				hiddenInput.value = src;
				fileInput.dispatchEvent(new Event("change", { bubbles: true }));
			};
			openSignaturePopup(setImgSrc);
		}
	});
}

const signature = registerComponent(createSignaturePicker);

function init(context, selector = "input[type=file][data-signature]") {
	return signature(selector, context);
}

export { signature, init };
